export default 'https://tme.understood.org/assets/outro.en.8adb58a0.vtt'